
// PATHS
import axios from "axios";
import { replaceObjectsInUrls } from "../utils";

const SEARCH_RS = 'network/repair-shop/search';
const UPDATE_GENERAL_INFO_RS = '/network/repair-shop/updateGeneralInfo';
const UPDATE_ADDITIONAL_INFO_RS = '/network/repair-shop/additionalInfo/update';
const UPDATE_FINANCIAL_INFO_RS = '/network/repair-shop/financialInfo/update';
const UPDATE_EPARKING_INFO_RS = '/network/repair-shop/eParking/update';
const GET_RS_BY_ID = 'network/repair-shop/findById/{id}';
const INSERT_DOCUMENTS_RS = '/network/documents/repair-shop/upload';
const GET_DOCUMENTS_RS = '/network/documents/repair-shop/findDocuments/{id}';
const DOWNLOAD_DOCUMENT_RS = '/network/documents/repair-shop/getBase64/{idDoc}';
const DELETE_DOCUMENT_RS = '/network/documents/repair-shop/delete/{idDoc}';

const GET_REPAIR_SHOPS_OBJ = 'network/repair-shop/repairShopsObject';
const EXPORT_RS = 'network/repair-shop/export';


const search: any = async (req: any) => {
    const response = await axios.post(SEARCH_RS, req);
    return response.data;
}

const updateGeneralInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_GENERAL_INFO_RS, req);
    return response.data;
}

const updateAdditionalInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_ADDITIONAL_INFO_RS, req);
    return response.data;
}

const updateEparkingInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_EPARKING_INFO_RS, req);
    return response.data;
}

const updateFinancialInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_FINANCIAL_INFO_RS, req);
    return response.data;
}

const getRepairShopById: any = async (req:any) => {
    const response = await axios.get(replaceObjectsInUrls(GET_RS_BY_ID, req));
    return response.data;
}

const insertDocumentRs: any = async (req:any) => {
    const response = await axios.post(INSERT_DOCUMENTS_RS, req);
    return response.data;
}

const getDocumentsRs: any = async (req: any) => {
    const response = await axios.get(replaceObjectsInUrls(GET_DOCUMENTS_RS, req))
    return response.data;
}

const downloadDocumentsRs: any = async (req: any) => {
    const response = await axios.get(replaceObjectsInUrls(DOWNLOAD_DOCUMENT_RS, req))
    return response.data;
}

const deleteDocumentsRs: any = async (req: any) => {
    const response = await axios.post(replaceObjectsInUrls(DELETE_DOCUMENT_RS, req))
    return response.data;
}

const getRepairShopsObj: any = async () => {
    const response = await axios.get(GET_REPAIR_SHOPS_OBJ)
    return response.data;
}
const exportRS: any = async (req: any) => {
    return new Promise(function (resolve, reject) {
        axios.post(EXPORT_RS, req, {
            responseType: 'arraybuffer',
            headers: { 'Access-Control-Allow-Origin': true,
                        'Content-Type': 'application/json' }
        }
        ).then(function (response) {
            resolve(response);
        }).catch(function (error) {
            reject(error)
        })
    });
}


export {
    search,
    updateGeneralInfo,
    updateAdditionalInfo,
    updateFinancialInfo,
    updateEparkingInfo,
    getRepairShopById,
    insertDocumentRs,
    getRepairShopsObj,
    getDocumentsRs,
    downloadDocumentsRs,
    deleteDocumentsRs,
	exportRS
}